import FilledButtonM from "@common/components/button/FilledButtonM"
import { theme } from "@common/theme/theme"
import { IS_WEB } from "@common/utils/mobileUtils"
import * as WebBrowser from "expo-web-browser"
import React from "react"
import { View } from "react-native"
import WebView from "react-native-webview"

/**
 * The training video, played inside the app: an iframe on web, a WebView on
 * native — the pattern of the tutor charter in CompleteTutorProfileStepper.
 * `embedUrl` comes from the server (Loom, YouTube); when it has none, the
 * video opens in the browser instead.
 */
export function TrainingVideoPlayer({ embedUrl, videoUrl, width }) {
    const height = Math.round((width * 9) / 16)

    if (!embedUrl) {
        return (
            <FilledButtonM
                icon="play-circle"
                color={theme.colors.primary}
                label="Voir la vidéo"
                style={{ width: null, alignSelf: "flex-start" }}
                onPress={() =>
                    IS_WEB
                        ? window.open(videoUrl, "_blank")
                        : WebBrowser.openBrowserAsync(videoUrl)
                }
            />
        )
    }

    return (
        <View
            style={{
                width,
                height,
                borderRadius: 12,
                overflow: "hidden",
                backgroundColor: "#000",
            }}
        >
            {IS_WEB ? (
                <iframe
                    src={embedUrl}
                    title="Vidéo de formation"
                    style={{ width: "100%", height: "100%", border: 0 }}
                    allow="autoplay; fullscreen; picture-in-picture"
                    allowFullScreen
                />
            ) : (
                <WebView
                    style={{ flex: 1 }}
                    source={{ uri: embedUrl }}
                    allowsFullscreenVideo
                    allowsInlineMediaPlayback
                    mediaPlaybackRequiresUserAction={false}
                />
            )}
        </View>
    )
}
